const WORKOUT_EXERCISES_ENDPOINT = {
  ROOT: '/workout-exercises',
  BY_ID: '/workout-exercises/:id'
}

export { WORKOUT_EXERCISES_ENDPOINT }
